<template>
  <div class="h5-upload clear ">
    <!--       单图片情况 -->
      <div class="delete-box" v-if="imageFile.length>0&&maxCount<=1">
        <el-image
          :src="imageFile"
          :preview-src-list="[imageFile]"
        >
          <!--加载失败-->
          <div class="el-image__error" slot="error">{{$t('other.loadFail')}}</div>
        </el-image>
        <div class="delete-icon">
          <img @click="deleteImg" :src="require('@/assets/PC/icons/icon-delete@2x.png')" alt="" />
        </div>
      </div>
<!--    多图片情况-->
      <template v-else>
        <div class="delete-box" v-for="(imgItem,imgIndex) in imageFile">
          <el-image
            :src="imgItem"
            :preview-src-list="imageFile">
            <!--加载失败-->
            <div class="el-image__error" slot="error">{{$t('other.loadFail')}}</div>
          </el-image>
          <div class="delete-icon">
            <img @click="deleteImg_mutiOneCase(imgIndex)" :src="require('@/assets/PC/icons/icon-delete@2x.png')" alt="" />
          </div>
        </div>
      </template>
      <el-upload
        v-if="maxCount<=1&&imageFile.length == 0 || maxCount>1&&imageFile.length<maxCount"
        action=""
        class="avatar-uploader"
        :show-file-list="false"
        :before-upload="afterRead">
        <!--        <img v-if="imageFile&&maxCount<=1" :src="imageFile" class="avatar">-->
        <div class="upload-desc">
          <img :src="require('@/assets/PC/img/plus@2x.png')" alt="" />
          <div>{{ $t('pc.upload') }}</div>
        </div>
      </el-upload>
  </div>


</template>

<script>
export default {
  name: "h5Upload",
  props: {
    maxCount: {
      type: Number,
      default: 1,
    },
    keyValue: {
      type: String,
      default: "",
    },
    id: {
      type:[Number, String],
      default:0
    },
    staticSmallImg_mutiOneCase: {
      type: String,
      default: '',
    },
    staticBigImg_mutiOneCase: {
      type: String,
      default: '',
    }
  },
  data(){
    return {
      images:null,
      show: false,
      fileList: [],
      _fileList: [],
      imageFile:[]
    }
  },
  methods: {
    // 预览图片
    showViewImage(img){
      this.show = true
      this.images = Array.isArray(img) ? img : [img]
    },
    afterRead(file) {
      file.status = 'uploading'
      file.message = this.$t('upload.uploading')
      this.getBase64(file).then(resBase64 => {
        if(this.maxCount<=1){
          this.imageFile = resBase64
        }else{
          this.imageFile.push(resBase64)
        }
      })
      const params = {
        file: file,
        key: this.keyValue,
        photoIndex:0
      };
      // 上传结束后的回调
      params.uploadCallback = (res) => {
        console.log('---执行callback', res)
        if(res){
          file.status = 'done'
          file.message = '上传成功'
        }else{
          file.status = 'failed'
          file.message = this.$t('upload.uploadFail')
        }
      }

      this.$emit("afterRead", params);
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        //开始转
        reader.onload = function() {
          fileResult = reader.result;
        };
        //转 失败
        reader.onerror = function(error) {
          reject(error);
        };
        //转 结束  咱就 resolve 出去
        reader.onloadend = function() {
          resolve(fileResult);
        };
      });
    },
    deleteImg(imgIndex){
      const params = {
        key: this.keyValue,
        photoIndex:imgIndex||0,
        id:this.id
      };
      this.imageFile = []
      this.$emit('delete',params)
    },
    deleteImg_mutiOneCase(photoIndex){
      const params = {
        key: this.keyValue,
        photoIndex,
        id:this.id
      };
      this.imageFile.splice(photoIndex, 1)
      console.log(params)
      this.$emit('delete',params)
      return true
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .staticSmallImg_mutiOneCase .van-uploader__preview{
  display: none;
}
  .img-item-staticBigImg_mutiOneCase {
    margin-bottom: 9px;
    width: 150px;
    // display: inline-block;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .img-item-staticBigImg_mutiOneCase:nth-child(2n+1){
    margin-right: 20px;
  }
  .img-item-0{
    margin-bottom: 0;
  }
.uploader {
  width: 150px;
  height: 150px;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .img-tips {
    width: 40px;
    height: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .desc {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999;
    margin-top: 10px;
  }
}

.h5-upload {
  & /deep/ .van-uploader__wrapper{
      flex-wrap: wrap;
      margin-right:0;
    }
  & /deep/ .van-uploader {
    .van-uploader__preview {
      justify-content: space-between;
      flex-wrap: wrap;
      margin-right:0;
      margin-bottom:0;
    }

    .van-image {
      width: 200px;
      height: 200px;
      margin-bottom: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .van-uploader__preview:nth-child(2n+1) {
      // margin-right: 20px;
    }
    .van-uploader__input-wrapper{
      justify-content: space-between;
      flex-wrap: wrap;
      margin-right:0;
    }

  }


}

  .uploader{
    display: flex;
    justify-content: center;
    align-items: center
  }
  .h5-upload.clear{
    // background: #f2f2f2 !important;
    //width: 150px;
    // height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ div {
    .van-uploader__input-wrapper{
      width: 200px !important;
      height: 200px !important;
      display: flex;
      justify-content: center !important;
      align-items: center;
      background: #f2f2f2;
      .uploader{
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .img-tips{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0;
        img{
          margin-right: 0;
        }
      }
    }
  }
  /deep/ .van-uploader__preview-delete {
    width: 40px;
    height: 40px;
    border-radius: 0 0 0 40px;
  }
  /deep/ .van-uploader__preview-delete-icon::before {
    width: 20px;
    height: 20px;
    font-size: 20px !important;
  }
  /deep/ .van-uploader__preview-delete-icon {
    top: 6px;
    right: 6px;
  }

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.upload-desc {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  text-align: center;
  display: flex;
  background: #f2f2f2;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  >div{
    font-size: 14px;
  }
  img{
    width: 40px;
    height: 40px;
  }
}
/deep/ .el-image {
  width: 200px;
  height: 200px;
}
.delete-box{
  position: relative;
  background: #FFFFFF;
  opacity: 1;
  overflow: hidden;
  //margin-right: 12px;

  .delete-icon{
    position: absolute;
    top: -40px;
    right: -40px;
    background: black;
    width: 80px;
    height: 80px;
    text-align: center;
    border-radius: 50%;
    opacity: 0.5;
    img{
      cursor: pointer;
      width: 20px;
      height: 20px;
      margin-top: 46px;
      margin-right: 38px;
    }
  }
}


</style>
